import { render } from "./LoadingComponent.vue?vue&type=template&id=4c1e37a2&scoped=true"
const script = {}

import "./LoadingComponent.vue?vue&type=style&index=0&id=4c1e37a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1e37a2"]])

export default __exports__